import React from 'react';
import PropTypes from 'prop-types';
import { TIME_FRAME } from 'utils/constanst';

const TIME_UNIT_LABELS = {
  [TIME_FRAME.TEN_MINUTES]: '10分単位',
  [TIME_FRAME.DAY]: '1時間単位',
  [TIME_FRAME.MONTH]: '1日単位',
  [TIME_FRAME.WEEK]: '1週単位',
  [TIME_FRAME.YEAR]: '1か月単位'
};

const TimeUnitSelector = ({ timeUnit, onChange }) => (
  <select value={timeUnit} onChange={onChange} className="time-unit-selector" style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}>
    {Object.entries(TIME_UNIT_LABELS).map(([value, label]) => (
      <option key={value} value={value}>{label}</option>
    ))}
  </select>
);

TimeUnitSelector.propTypes = {
  timeUnit: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TimeUnitSelector;
